module.exports = __webpack_public_path__ + "img/ic_h5_vip4.aac550d0.png";